<template>
  <div
    class="font-heading brand-heading fixed left-0 top-0 h-screen w-full overflow-hidden overflow-y-auto"
    style="width: 75vw; max-width: 25rem; padding-right: 1px"
  >
    <div class="">
      <div class="brand-heading w-full p-4 px-5">
        <div
          :class="{
            'text-sm text-gray-500': isAuthenticated,
            'text-base, text-grey-800': !isAuthenticated,
          }"
        >
          {{ getWelcomeText() }}
        </div>
        <div class="text-lg">
          <span v-if="isAuthenticated"> {{ forename }} {{ surname }} </span>
          <router-link to="/trophies">
            <AchievementScore
              v-if="isAuthenticated"
              class="ml-1"
              :score="achievementScore"
            />
          </router-link>
          <div
            v-if="!isAuthenticated"
            class="mt-2 text-sm text-gray-500"
          >
            <router-link :to="{ name: 'login' }">
              Have we met before? If so,
              <span class="text-brand-500"> you can login here. </span>
            </router-link>
            <router-link
              class="mt-2 inline-block"
              :to="{ name: 'membershipClub' }"
            >
              If you're new to the app, we're happy to see a new face. To get more out of the app,
              we recommend
              <span class="text-brand-500"> registering an account here. </span>
            </router-link>
          </div>
        </div>
      </div>
      <hr class="b-bottom mx-4">
      <div
        v-if="!isExpired && isAuthenticated"
        class="p-2 text-center text-sm uppercase text-white"
        :class="expiringSoon ? 'bg-yellow-300' : ' bg-gradient-to-br from-brand-200 to-brand-500'"
      >
        <div class="text-xxs mb-1 font-normal leading-none">
          {{ $membershipTerm() }} expires
        </div>
        <div class="brand-heading leading-none">
          {{ $moment(membershipExpires).format('dddd, Do MMMM YYYY') }}
        </div>
      </div>

      <div
        v-if="isExpired"
        class="bg-red-600 p-3 text-center text-sm font-semibold uppercase text-white"
      >
        <div
          v-if="completedFirstPayment"
          class="leading-none"
        >
          {{ $membershipTerm() }} expired
        </div>
        <div
          v-if="!completedFirstPayment"
          class="leading-none"
        >
          No {{ $membershipTermLower() }}
        </div>
      </div>

      <div
        v-if="isAuthenticated"
        class="brand-heading flex border-y border-gray-100 text-left"
        @click="closeSideMenu()"
      >
        <router-link
          to="/points/"
          class="flex w-1/2 items-center justify-center border-r border-gray-100 p-4"
        >
          <div
            class="mr-2 leading-none"
            style="font-size: 1.425rem"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="home"
              class="text-gray-700"
              style="height: 1.7rem; width: 1.7rem"
              role="img"
              viewBox="0 0 576 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M336 463.59V368a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v95.71a16 16 0 0 1-15.92 16L112 480a16 16 0 0 1-16-16V300.06l184.39-151.85a12.19 12.19 0 0 1 15.3 0L480 300v164a16 16 0 0 1-16 16l-112-.31a16 16 0 0 1-16-16.1z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M573.32 268.35l-25.5 31a12 12 0 0 1-16.9 1.65L295.69 107.21a12.19 12.19 0 0 0-15.3 0L45.17 301a12 12 0 0 1-16.89-1.65l-25.5-31a12 12 0 0 1 1.61-16.89L257.49 43a48 48 0 0 1 61 0L408 116.61V44a12 12 0 0 1 12-12h56a12 12 0 0 1 12 12v138.51l83.6 68.91a12 12 0 0 1 1.72 16.93z"
                />
              </g>
            </svg>
          </div>
          <div>
            <div class="text-sm font-semibold leading-none text-gray-800">
              {{ homePoints }}
            </div>
            <div class="text-xs uppercase leading-none text-gray-800">
              Home
            </div>
          </div>
        </router-link>
        <router-link
          to="/points/flexi"
          class="flex w-1/2 items-center justify-center p-4"
        >
          <div
            class="mr-2 leading-none"
            style="font-size: 1.55rem"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="random"
              class="text-gray-700"
              style="height: 1.6rem; width: 1.6rem"
              role="img"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M505 359l-80-80c-15-15-41-4.47-41 17v40h-32l-52.78-56.55-53.33 57.14 70.55 75.6a12 12 0 0 0 8.77 3.81H384v40c0 21.46 26 32 41 17l80-80a24 24 0 0 0 0-34zM122.79 96H12a12 12 0 0 0-12 12v56a12 12 0 0 0 12 12h84l52.78 56.55 53.33-57.14-70.55-75.6a12 12 0 0 0-8.77-3.81z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M505 119a24 24 0 0 1 0 34l-80 80c-15 15-41 4.48-41-17v-40h-32L131.56 412.19a12 12 0 0 1-8.77 3.81H12a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h84L316.44 99.81a12 12 0 0 1 8.78-3.81H384V56c0-21.44 25.94-32 41-17z"
                />
              </g>
            </svg>
          </div>
          <div>
            <div class="text-sm font-semibold leading-none text-gray-800">
              {{ flexiPoints }}
            </div>
            <div class="text-xs uppercase leading-none text-gray-800">
              Flexi
            </div>
          </div>
        </router-link>
      </div>

      <div class="p-4 px-5">
        <div
          v-if="$isStandard && !isExpired && completedFirstPayment && !isExperienceMember"
          class="flex items-center py-3"
          @click="navigate('/membership-pack', 'Membership Pack')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="envelope"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            {{ $membershipTerm() }} Pack
          </div>
        </div>

        <div
          v-if="$isStandard && isAuthenticated"
          class="flex items-center py-3"
          @click="navigate('/morebenefits', 'MoreBenefits')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="hand-holding-medical"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 576 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M559.73,392.21l-135,99.52A104.8,104.8,0,0,1,363,512H16A16.11,16.11,0,0,1,0,496V400a16.11,16.11,0,0,1,16-16H71.37l46.5-37.74A117.7,117.7,0,0,1,192,320H352a32.07,32.07,0,0,1,31.62,37.38C381,373.15,366.22,384,350.23,384H272a16,16,0,0,0,0,32H392.59l119.67-88.18a40,40,0,1,1,47.47,64.37Z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M400,96v64a16,16,0,0,1-16,16H320v64a16,16,0,0,1-16,16H240a16,16,0,0,1-16-16V176H160a16,16,0,0,1-16-16V96a16,16,0,0,1,16-16h64V16A16,16,0,0,1,240,0h64a16,16,0,0,1,16,16V80h64A16,16,0,0,1,400,96Z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            MoreBenefits
          </div>
        </div>

        <div
          v-if="isAuthenticated && healthKeyShopEnabled"
          class="flex items-center py-3"
          @click="navigate('/healthkey', 'HealthKey')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="heart"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M228 170h56v52h52v56h-52v52h-56v-52h-52v-56h52z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            HealthKey
          </div>
        </div>

        <div
          v-if="$isStandard"
          class="flex items-center py-3"
          @click="navigate('/purchaseGiftCard', giftCardsName)"
        >
          <div class="w-6 text-center">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="gift"
              class="mx-auto"
              :class="{
                'text-black': isBF || isBFEarlyAccess,
                'text-gray-500': !isBF && !isBFEarlyAccess,
              }"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  opacity="0.4"
                  fill="currentColor"
                  d="M224 320v160H64a32 32 0 0 1-32-32V320zm0-160H32a32 32 0 0 0-32 32v80a16 16 0 0 0 16 16h208zm256 0H288v128h208a16 16 0 0 0 16-16v-80a32 32 0 0 0-32-32zM288 480h160a32 32 0 0 0 32-32V320H288z"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M224 480h64V320h-64zM359.54 32c-41.82 0-68.86 21.3-103.54 68.3-34.68-47-61.72-68.3-103.54-68.3C103.71 32 64 71.5 64 120a85.65 85.65 0 0 0 10.15 40h78.21a40 40 0 1 1 0-80c20 0 34.78 3.3 86.55 80H224v128h64V160h-15c51.67-76.5 66-80 86.55-80a40 40 0 1 1 0 80h78.31A86.86 86.86 0 0 0 448 120c0-48.5-39.71-88-88.46-88z"
                />
              </g>
            </svg>
          </div>

          <div
            class="ml-3 text-base leading-none text-gray-800"
            :class="{ 'font-semibold': isBF || isBFEarlyAccess }"
          >
            {{ giftCardsName }}
          </div>
        </div>

        <div
          v-if="$isStandard && isAuthenticated && completedFirstPayment"
          class="flex items-center py-3"
          @click="navigate('/trophies', 'Trophies')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 576 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M231.1 187.3l-9.4 54.6a12 12 0 0 0 17.4 12.6l49-25.8 49 25.8a12 12 0 0 0 17.4-12.6l-9.4-54.6 39.6-38.6c7.1-6.9 3.2-19-6.4-20.5l-54.8-8L299 70.6a12 12 0 0 0-21.5 0L253 120.2l-54.8 8a12 12 0 0 0-6.7 20.5zM384 432H192c-35.3 0-64 20.7-64 56v12a12 12 0 0 0 12 12h296a12 12 0 0 0 12-12v-12c0-35.3-28.7-56-64-56z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M552.12 64H448V24a23.94 23.94 0 0 0-23.88-24H152a23.94 23.94 0 0 0-24 23.88V64H24A23.94 23.94 0 0 0 0 87.88V144c0 66.5 77.9 131.7 171.9 142.4C203.3 338.5 240 360 240 360v72h96v-72s36.7-21.5 68.1-73.6C498.4 275.6 576 210.3 576 144V88a23.94 23.94 0 0 0-23.88-24zM64 144v-16h64.2a359 359 0 0 0 12.8 86.2c-47.5-16.4-77-49.9-77-70.2zm320.7 4.7l-39.6 38.6 9.4 54.6a12 12 0 0 1-17.4 12.6l-49-25.8-49 25.8a12 12 0 0 1-17.4-12.6l9.4-54.6-39.6-38.6a12 12 0 0 1 6.7-20.5l54.8-8 24.5-49.6a12 12 0 0 1 21.5 0l24.5 49.6 54.8 8c9.6 1.5 13.5 13.6 6.4 20.5zM512 144c0 20.2-29.4 53.8-77 70.2a359 359 0 0 0 12.8-86.2H512z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Trophies
          </div>
        </div>

        <div
          v-if="isAuthenticated"
          class="flex items-center py-3"
          @click="navigate('/subscription', 'Subscription')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="sync-alt"
              class="mx-auto h-4 w-4 text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M8 454.06V320a24 24 0 0 1 24-24h134.06c21.38 0 32.09 25.85 17 41l-41.75 41.75A166.82 166.82 0 0 0 256.16 424c77.41-.07 144.31-53.14 162.78-126.85a12 12 0 0 1 11.65-9.15h57.31a12 12 0 0 1 11.81 14.18C478.07 417.08 377.19 504 256 504a247.14 247.14 0 0 1-171.31-68.69L49 471c-15.15 15.15-41 4.44-41-16.94z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M12.3 209.82C33.93 94.92 134.81 8 256 8a247.14 247.14 0 0 1 171.31 68.69L463 41c15.12-15.12 41-4.41 41 17v134a24 24 0 0 1-24 24H345.94c-21.38 0-32.09-25.85-17-41l41.75-41.75A166.8 166.8 0 0 0 255.85 88c-77.46.07-144.33 53.18-162.79 126.85A12 12 0 0 1 81.41 224H24.1a12 12 0 0 1-11.8-14.18z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Subscription
          </div>
        </div>

        <div
          v-if="isAuthenticated"
          class="flex items-center py-3"
          @click="navigate('/history', 'History')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="history"
              style="height: 1.05rem; width: 1.05rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M141.68 400.23a184 184 0 1 0-11.75-278.3l50.76 50.76c10.08 10.08 2.94 27.31-11.32 27.31H24a16 16 0 0 1-16-16V38.63c0-14.26 17.23-21.4 27.31-11.32l49.38 49.38A247.14 247.14 0 0 1 256 8c136.81 0 247.75 110.78 248 247.53S392.82 503.9 256.18 504a247 247 0 0 1-155.82-54.91 24 24 0 0 1-1.84-35.61l11.27-11.27a24 24 0 0 1 31.89-1.98z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M288 152v104.35L328.7 288a24 24 0 0 1 4.21 33.68l-9.82 12.62a24 24 0 0 1-33.68 4.21L224 287.65V152a24 24 0 0 1 24-24h16a24 24 0 0 1 24 24z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            History
          </div>
        </div>

        <div
          v-if="isAuthenticated"
          class="flex items-center py-3"
          style="margin-top: -3px"
          @click="navigate('/profile', 'Profile')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="users-cog"
              style="height: 1.4rem; width: 1.4rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 640 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="currentColor"
                  d="M636.3 356.1l-25.8-14.9a117.31 117.31 0 0 0 0-42.6l25.8-14.9a7.24 7.24 0 0 0 3.3-8.5 150.07 150.07 0 0 0-33.2-57.4 7.29 7.29 0 0 0-9-1.4l-25.8 14.9a117.4 117.4 0 0 0-36.9-21.3v-29.8a7.28 7.28 0 0 0-5.7-7.1 150.88 150.88 0 0 0-66.2 0 7.28 7.28 0 0 0-5.7 7.1V210a117.4 117.4 0 0 0-36.9 21.3l-25.8-14.9a7.31 7.31 0 0 0-9 1.4 150.07 150.07 0 0 0-33.2 57.4 7.37 7.37 0 0 0 3.3 8.5l25.8 14.9a117.31 117.31 0 0 0 0 42.6l-25.8 14.9a7.24 7.24 0 0 0-3.3 8.5 150.82 150.82 0 0 0 33.2 57.4 7.29 7.29 0 0 0 9 1.4l25.8-14.9a117.4 117.4 0 0 0 36.9 21.3v29.8a7.28 7.28 0 0 0 5.7 7.1 150.88 150.88 0 0 0 66.2 0 7.28 7.28 0 0 0 5.7-7.1v-29.8a117.4 117.4 0 0 0 36.9-21.3l25.8 14.9a7.31 7.31 0 0 0 9-1.4 150.07 150.07 0 0 0 33.2-57.4 7.37 7.37 0 0 0-3.3-8.5zM496 368.4a48.5 48.5 0 1 1 48.5-48.5 48.55 48.55 0 0 1-48.5 48.5z"
                  opacity="0.4"
                />
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M320 255.9c1.9 0 3.7-.5 5.6-.6a184.35 184.35 0 0 1 36.3-59.2 39.41 39.41 0 0 1 28.9-12.6 38.44 38.44 0 0 1 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4a110.69 110.69 0 0 0 11.2-48A112 112 0 1 0 320 255.9zm-146.9 18.6a63.81 63.81 0 0 0-45.1-18.6H64a64.06 64.06 0 0 0-64 64v32a32 32 0 0 0 32 32h65.9a146.64 146.64 0 0 1 75.2-109.4zM96 223.9a64 64 0 1 0-64-64 64.06 64.06 0 0 0 64 64zm329.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8a39.75 39.75 0 0 1-28.9-12.6 182.34 182.34 0 0 1-40.2-69.6c-10.7-34.5 24.9-49.7 25.8-50.3q-.15-3.9 0-7.8l-7.9-4.6a40.73 40.73 0 0 1-9.8-8.1c-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3A115.25 115.25 0 0 0 128 403.1v28.8a48 48 0 0 0 48 48h255.4a38.5 38.5 0 0 1-6.2-20.3z"
                />
              </g>
            </svg>
          </div>

          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Profile
          </div>
        </div>

        <div
          v-if="$isStandard"
          class="flex items-center py-3"
          style="margin-top: -3px"
          @click="navigate('/info', 'info')"
        >
          <div class="w-6 text-center">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="info-circle"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
              />
            </svg>
          </div>
          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            News & Updates
          </div>
        </div>

        <div
          class="flex items-center py-3"
          style="margin-top: -3px"
          @click="navigate('/support', 'support')"
        >
          <div class="w-6 text-center">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="info-circle"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M288 256H32a32 32 0 0 0-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288a32 32 0 0 0-32-32zM160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm288-224v64h64v-64z"
                opacity="0.4"
              />
              <path
                fill="currentColor"
                d="M544 160H224a32 32 0 0 0-32 32v32h96a64.09 64.09 0 0 1 63.71 57.82l.29-.22V416h192a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zm-32 128h-64v-64h64zm-64-160V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v192h96v-32a64.07 64.07 0 0 1 64-64z"
              />
            </svg>
          </div>
          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Help & Contact
          </div>
        </div>

        <div
          class="flex items-center py-3"
          style="margin-top: -3px"
          @click="navigate('/settings', 'settings')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="cogs"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 640 512"
            >
              <path
                fill="currentColor"
                d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
              />
            </svg>
          </div>
          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Settings
          </div>
        </div>

        <div
          class="flex items-center py-3"
          style="margin-top: -3px"
          @click="navigate('/termsandpolicies', 'termsAndPolicies')"
        >
          <div class="w-6 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="cogs"
              style="height: 1.2rem; width: 1.2rem"
              class="mx-auto text-gray-500"
              role="img"
              viewBox="0 0 384 512"
            >
              <path
                class="fa-secondary"
                d="M320 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V64C384 28.65 355.3 0 320 0zM208 352h-128C71.16 352 64 344.8 64 336S71.16 320 80 320h128c8.838 0 16 7.164 16 16S216.8 352 208 352zM304 256h-224C71.16 256 64 248.8 64 240S71.16 224 80 224h224C312.8 224 320 231.2 320 240S312.8 256 304 256zM304 160h-224C71.16 160 64 152.8 64 144S71.16 128 80 128h224C312.8 128 320 135.2 320 144S312.8 160 304 160z"
              />
            </svg>
          </div>
          <div class="ml-3 text-base font-normal leading-none text-gray-800">
            Terms & Policies
          </div>
        </div>

        <!-- <div class="pl-5 pb-8 inset-x-0 bottom-0 absolute">
          <div
            class="relative flex items-center"
            @click.stop="closeSideMenu()"
          >
            <div class="w-6 text-center relative inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="times-circle"
                style="height: 1rem; width: 1rem;"
                class="text-gray-500 ml-auto mr-auto"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M377.6 321.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"
              /></g></svg>
            </div>

            <div class="text-gray-800 ml-3 leading-none relative inline-block font-normal">
              Close Menu
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AchievementScore from '@/app/shared/components/trophies/score.vue';
import { FeatureFlags } from '@/app/shared/constants/featureFlags';

export default {
  name: 'SideBar',

  components: {
    AchievementScore,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({
      username: state => state.user.username,
      homeClubName: state => state.user.homeClubName,
      forename: state => state.user.forename,
      surname: state => state.user.surname,
      homePoints: state => state.user.homePoints,
      flexiPoints: state => state.user.flexiPoints,
      membershipExpires: state => state.user.membershipExpires,
      isExpired: state => state.user.IsExpired,
      expiringSoon: state => state.user.expiringSoon,
      completedFirstPayment: state => state.user.completedFirstPayment,
      achievementScore: state => state.user.achievementScore,
      isAuthenticated: state => state.user.isAuthenticated,
    }),

    ...mapGetters({
      currentTheme: 'getCurrentTheme',
      isExperienceMember: 'isExperienceMember',
    }),
    ...mapGetters(['isBFEarlyAccess', 'isBFRegister', 'isBFHide', 'isBF']),

    giftCardsName() {
      if (this.isBFEarlyAccess || this.isBF) {
        return 'Black Friday Gift Cards!';
      }
      return 'Gift Cards';
    },

    healthKeyShopEnabled() {
      return FeatureFlags.HealthKeyShop;
    },
  },

  methods: {
    getWelcomeText() {
      const hours = new Date().getHours();

      if (hours < 12) {
        return 'Good Morning';
      }
      if (hours < 18) {
        return 'Good Afternoon';
      }

      return 'Good Evening';
    },

    navigate(path, name) {
      this.$emit('open', { path, name });
    },
    closeSideMenu() {
      this.$store.dispatch('setSideMenuState', false);
    },
  },
};
</script>
